import React from 'react';
import ConsultationsNutritionist from '../components/NutritionistSchedule/Consultations';
import ConsultationsNutritionistV3 from '../components/NutritionistSchedule/ConsultationsV3';

const ScheduleNutritionist = props => {
  return <ConsultationsNutritionistV3 />;
};

export default ScheduleNutritionist;
